import React from "react"

export  const BaseUrl = "https://api.awlindia.com"